const AbsencesRequestView = () => <>{'ABSENCES REQUEST TABLE'}</>
export default AbsencesRequestView
